import { useNavigate } from '@tanstack/react-router';
import { Button } from 'components/ui/Button';
import { SectionLabel } from 'components/ui/SectionLabel';
import { RouterKey } from 'consts';
import { useLanguage } from 'context/language.context';
import { StringKey } from 'dictionaries/string-key.enum';
import { cn } from 'lib/utils';

export const NotFoundSection = () => {
  const { t, direction } = useLanguage();
  const navigate = useNavigate();

  return (
    <section className="relative w-full h-[calc(100vh-80px)] overflow-x-hidden bg-[#000006]">
      <div className="relative flex flex-col justify-center h-full px-20 max-md:px-4">
        <div className="relative z-[2] px-8 flex flex-col gap-8 max-md:p-0">
          <div className="relative lg:w-[65%] flex flex-col gap-6">
            <div className="flex flex-col gap-4 max-md:items-center">
              <SectionLabel>404</SectionLabel>
              <h1 className="bg-clip-text bg-label-gradient text-transparent font-semibold text-[60px] leading-[72px] max-md:text-[36px] max-md:leading-[44px] max-md:text-center">
                {t(StringKey.PAGE_NOT_FOUND)}
              </h1>
            </div>
            <p className="text-[20px] leading-[30px] max-md:text-[16px] max-md:leading-6 max-md:text-center max-md:font-normal">
              {t(StringKey.PAGE_NOT_FOUND_DESC)}
            </p>
          </div>
          <Button
            className="self-center md:self-start max-xs:grow px-5 py-3 md:px-[26px] md:py-4"
            onClick={() => navigate({ to: RouterKey.HOME_PAGE })}
          >
            {t(StringKey.BACK_TO_HOME)}
          </Button>
        </div>
      </div>

      <div
        className={cn('absolute z-[1] h-full top-0', direction === 'rtl' ? 'left-0' : 'right-0')}
      >
        <img
          className="h-full object-cover"
          src={`/assets/door-bg${direction === 'rtl' ? '-ar' : ''}.png`}
          alt="Door background"
        />
      </div>
    </section>
  );
};
